import React, { useState } from 'react';
import Link from 'next/link';
import { Sphere } from '../_shared';
import { customers } from '../../components/_dummyData/customers';
import { useEffectOnce } from 'react-use';
import { Card } from './components/Card';
import styles from './Customers.module.scss';
import { numberWithCommas } from '../../utils/helpers';

export type CardProps = {
    title: string;
    rows: string[];
    icon: string;
    backgroundColor: string;
};

export type CustomersProps = {
    participantCount: number;
};

export const Customers: React.FC<CustomersProps> = ({ participantCount }) => {
    const [data, setData] = useState<CardProps[]>([]);

    useEffectOnce(() => {
        setData(customers);
    });

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div>
                    <Sphere
                        zIndex={1}
                        color="blue"
                        step={0.009}
                        maxMove={20}
                        opacity={0.7}
                    />
                </div>
                <h1 className={styles.title}>Заказчикам</h1>
                <div className={styles.cardWrapper}>
                    {data?.map((el, idx) => {
                        return <Card key={idx} card={el} />;
                    })}
                    <div className={styles.info}>
                        <div>
                            Сейчас на площадке <br />{' '}
                            {numberWithCommas(participantCount, ' ')}{' '}
                            участников.
                        </div>
                        <div>Будьте успешными вместе с нами!</div>
                        <Link href="/auth/registration">
                            <a className={styles.link}>Зарегистрироваться</a>
                        </Link>
                    </div>
                </div>
                <div className={styles.sytemsContainer}>
                    <div>Интеграция с внешними системами</div>
                    <div>
                        <span>
                            <img
                                src="/assets/customers/eis.svg"
                                alt="SystemIcon"
                            />
                        </span>
                        <span>
                            <img
                                src="/assets/customers/keysystems.svg"
                                alt="SystemIcon"
                            />
                        </span>
                        <span>
                            <img
                                src="/assets/customers/easuz.svg"
                                alt="SystemIcon"
                            />
                        </span>
                        <span>
                            <a
                                href="https://izhtender.ru/moskva/soprovozhdenie-torgov/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src="/assets/customers/izhtender.png"
                                    alt="SystemIcon"
                                />
                            </a>
                        </span>
                    </div>
                    <div>и другие</div>
                </div>
            </div>
        </div>
    );
};
